import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  hide: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  bottomNavDif: {
    marginLeft: -20,
    padding: 0,
    maxWidth: 100,
  },
  bottomNav: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 30,
    marginLeft: 30,
  },
  paper: {
    position: "fixed",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 99,
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  mainBox: {
    height: "calc(100vh - 125px)",
    // mainlayout
    flex: "1",
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 100px)",
    },
    //
    flexGrow: 1,
    overflow: "hidden",
  },
  gridMain: {
    flex: "auto",
    [theme.breakpoints.down("sm")]: {
      marginBottom: 6,
    },
    [theme.breakpoints.down("md")]: {
      marginBottom: 6,
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
    },
    // marginBottom: { xs: 6, sm: 6, md: 6, lg: 0 },
  },
  rightContainerHeader: {
    position: "relative",
    width: "100%",
  },
  header: {
    // height: 64,
    width: "100%",
    position: "relative", // or fixed if you want it sticky
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    // zIndex: 10,
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    padding: "20px",
    [theme.breakpoints.down("sm")]: {
      padding: "15px",
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "0px",
      padding: "15px",
    },
  },
  box: {
    maxHeight: "100vh",
    overflow: "hidden",
  },
  grid: {
    width: "13rem",
    // width: "65px",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
    [theme.breakpoints.up("md")]: {
      display: "block",
    },
  },
  spin: {
    height: "100vh",
    width: "100wh",
    backgroundColor: "#e6d9ec",
    color: theme.palette.primary.main,
  },
  appBar: {
    background: "#fff",
    color: "#000",
    boxShadow: "none",
  },
  appBarContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    gap: "5px",
  },
  profileUserName: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#404040",
  },
  profileUserRole: {
    fontFamily: "Poppins, sans-serif",
    fontWeight: 600,
    fontSize: "12px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#565656",
  },
  fallbackContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: "20px",
  },
}));
export default useStyles;
